/**
 * Константы, связанные с маршрутами приложения.
 * @type {string}
 */

// Руководитель проекта
export const ROUTE_NAME_LEADER_TEAM = 'leader-team'; // Запросы в команду с Витрины
export const ROUTE_NAME_LEADER_TEAM_REJECTED = 'leader-team-rejected'; // Отклоненные запросы в команду